import { fetchGroupsPrograms } from 'actions/Program/Group';
import { getProgramsOptions } from 'src/components/Groups/Programs/utils';
import {
  crtb1967DeactivatedProgramsInternalCasesFilter,
  crtb2646ShowProgramNameReferralsCasesDashboard,
} from 'src/common/utils/FeatureFlags/flags';
import { withBlankProgramOption } from 'src/components/Dashboard/utils/filterDefaults';

const fetchPrograms = (groupId, query = null, state) => async (dispatch, getState) => {
  const currentState = getState();
  const includeDeactivatedPrograms = crtb1967DeactivatedProgramsInternalCasesFilter(currentState);
  const programsFilter = { query, ...(!includeDeactivatedPrograms && { active: true }) };

  const { data: { data: programs } } = await dispatch(fetchGroupsPrograms(groupId, programsFilter));

  return withBlankProgramOption(getProgramsOptions(programs, state), {
    enabled: crtb2646ShowProgramNameReferralsCasesDashboard(currentState),
    selected: state.filters.programs_filter,
    query,
  });
};

export default fetchPrograms;
